import { jsx as o } from "react/jsx-runtime";
import "../../../ActionButton-B77eJAd5.js";
import "styled-components";
import "react";
import "../../../styles/icons/icons.js";
import "../../layout/Stack/Stack.js";
import "../../layout/Box/Box.js";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import "../../../hooks/link/index.js";
import "focus-trap-react";
import "@material/material-color-utilities";
import "../../content/Logo/consts.js";
import d from "../../controls/Dropdown/Dropdown.js";
import "react-select";
import "react-select/async";
import "../../controls/Toggle/CustomCheckbox.js";
import n from "../FieldError/FieldError.js";
import a from "../FieldLabel/FieldLabel.js";
import f from "../FieldLayout/FieldLayout.js";
function K(m) {
  const {
    name: r,
    label: t,
    error: p,
    showError: i = !1,
    size: e = "medium",
    ...l
  } = m;
  return /* @__PURE__ */ o(f, { showError: i, children: {
    label: /* @__PURE__ */ o(a, { htmlFor: r, children: t }),
    field: /* @__PURE__ */ o(
      d,
      {
        id: r,
        inputId: r,
        "aria-labelledby": r,
        name: r,
        size: e,
        error: i,
        ...l
      }
    ),
    error: /* @__PURE__ */ o(n, { children: p })
  } });
}
export {
  K as default
};
